export const legalPaths = ["doa", "cr", "hnir", "ais", "sea", "pbss", "od"];